package com.eladfinish.bible.contest.screens.settings.ui.components

import androidx.compose.runtime.Composable
import androidx.navigation.NavType
import com.eladfinish.bible.contest.navigation.NavigationDestination
import com.eladfinish.bible.contest.navigation.NavigationDestination.Companion.Companion.createTypeMap
import com.eladfinish.bible.contest.screens.settings.ui.components.model.SubSettingsComponentType
import dev.icerock.moko.resources.compose.localized
import kotlinx.serialization.Serializable
import kotlin.reflect.KType

@Serializable
data class ComponentNavigationDestination(val type: SubSettingsComponentType) : NavigationDestination {

    override val title: String
        @Composable
        get() = type.subtitle.localized()

    override val screenName: String = "SubSettingsComponent"

    companion object : NavigationDestination.Companion {

        override val typeMap: Map<KType, NavType<*>> = createTypeMap(SubSettingsComponentType.serializer())
    }
}
